import { React } from "react";
import { Button } from "antd";

const CommonButton = ({ label, onClick, disabled, className, style, name, htmlType, type, loading, key }) => {
  return (
    <Button
      name={name}
      onClick={onClick}
      disabled={disabled}
      className={className}
      style={style}
      htmlType={htmlType}
      type={type}
      loading={loading}
      key={key}
    >
      {label}
    </Button>
  );
};

export default CommonButton;
